import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  deliveryWithinFromModel,
  validateDeliveryWithinCondition,
  type DeliveryWithinState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const DELIVERY_WITHIN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DeliveryWithinState>>,
): ConditionType<DeliveryWithinState, Condition.ShippingWithin> => ({
  name: CONDITION_NAMES[Condition.DELIVERY_WITHIN],
  description(state) {
    return t("Within {{count}} days of delivery", { count: +state });
  },
  Details(props: ConditionTypeDetailsProps<DeliveryWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return deliveryWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.DELIVERY_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return validateDeliveryWithinCondition(state).valid;
  },
});
